export default "__VITE_ASSET__D3rCcH5r__"